import { useEffect, useRef, useState } from "react";
import api from "../api";

function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const rad = (x) => (x * Math.PI) / 180;
  const dLat = rad(lat2 - lat1);
  const dLng = rad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function nearestCity(cities, lat, lng) {
  let best = null;
  let bestD = Infinity;
  for (const c of cities) {
    if (typeof c.lat !== "number" || typeof c.lng !== "number") continue;
    const d = haversine(lat, lng, c.lat, c.lng);
    if (d < bestD) { bestD = d; best = c; }
  }
  return best;
}

// Loads the super-admin city list, then geo-detects the browser location once and
// auto-selects the nearest city — but only if that city actually has events listed.
export function useCityGeo(availableCityNames) {
  const [allCities, setAllCities] = useState([]);
  const [city, setCity] = useState("all");
  const [nearName, setNearName] = useState("");
  const didGeo = useRef(false);

  useEffect(() => {
    api.get("/cities").then(({ data }) => setAllCities(Array.isArray(data) ? data : [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (didGeo.current) return;
    if (!allCities.length || !availableCityNames || !availableCityNames.length) return;
    if (!navigator.geolocation) return;
    didGeo.current = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const near = nearestCity(allCities, pos.coords.latitude, pos.coords.longitude);
        if (near && availableCityNames.some((n) => n.toLowerCase() === near.name.toLowerCase())) {
          setNearName(near.name);
          setCity((cur) => (cur === "all" ? near.name : cur));
        }
      },
      () => {},
      { timeout: 8000, maximumAge: 600000 }
    );
  }, [allCities, availableCityNames]);

  return { city, setCity, nearName, allCities };
}
